module.exports = __webpack_public_path__ + "img/atp01.41538886.jpg";